import React, {useState} from "react";
import {Box, Button, ListItemIcon, ListItemText, MenuItem, MenuList, Popover} from "@mui/material";
import {IconBrain, IconPlus, IconSitemap, IconTerminal, IconVariable, IconWriting} from "@tabler/icons-react";
import {NodeType} from "../../../../../model/ModelData";
import {IconText} from "../../../../../assets/icons/IconText";
import {IconHook} from "../../../../../assets/icons/IconHook";
import {UI, rgba} from "../../uiTokens";

const FORM_NODE_TYPES = [
    {type: NodeType.TEXT, label: "Text", icon: <IconText fontSize="small"/>},
    {type: NodeType.INPUT, label: "Input", icon: <IconWriting size={18}/>},
    {type: NodeType.QA, label: "QA", icon: <IconBrain size={18}/>},
    {type: NodeType.RECOMMENDATION, label: "Recommendation", icon: <IconTerminal size={18}/>},
    {type: NodeType.HOOK, label: "Hook", icon: <IconHook fontSize="small"/>},
    {type: NodeType.START_FLOW, label: "Flow", icon: <IconSitemap size={18}/>},
    {type: NodeType.SET_VAR, label: "Set", icon: <IconVariable size={18}/>},
];

export const CreateFormNodeButton = ({onSelect}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const close = () => setAnchorEl(null);

    return (
        <Box sx={{px: 0, py: 0.5}}>
            <Button
                fullWidth
                variant="primary"
                startIcon={<IconPlus size={16}/>}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                sx={{textTransform: "none"}}
            >
                Create new form item
            </Button>
            <Popover
                anchorEl={anchorEl}
                open={open}
                onClose={close}
                anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                transformOrigin={{vertical: "top", horizontal: "left"}}
                slotProps={{
                    paper: {
                        sx: {
                            mt: 0.5,
                            width: 264,
                            px: 0.5,
                            borderRadius: "12px",
                            border: `1px solid ${rgba(UI.accent, 0.16)}`,
                            boxShadow: UI.shadow,
                        },
                    },
                }}
            >
                <MenuList dense sx={{py: 0.5}}>
                    {FORM_NODE_TYPES.map((item) => (
                        <MenuItem
                            key={item.type}
                            onClick={() => {
                                onSelect(item.type);
                                close();
                            }}
                            sx={{
                                borderRadius: "8px",
                                my: 0.15,
                                py: 0.75,
                                color: UI.muted,
                                "& .MuiListItemIcon-root": {minWidth: 30, color: UI.accent},
                                "& svg": {width: 18, height: 18},
                                "&:hover": {backgroundColor: rgba(UI.accent, 0.08), color: UI.ink},
                            }}
                        >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primaryTypographyProps={{fontSize: 13, fontWeight: 500}}>
                                {item.label}
                            </ListItemText>
                        </MenuItem>
                    ))}
                </MenuList>
            </Popover>
        </Box>
    );
};
